import clsx from 'clsx';
import OptinStep from './OptinStep';
import { useEffect } from 'react';
import { useFidCardFunnelTracking } from '../../../../../posthog/funnelTrackingFidCard';

const AUTOCOMPLETE_MAPPING = {
  'nom et prénom': 'name',
  email: 'email',
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NAME_REGEX = /^[a-zA-ZÀ-ÿ\s]{2,}$/;

const VALIDATION_REGEX = {
  name: NAME_REGEX,
  email: EMAIL_REGEX,
};

const InputStep = ({
                     value,
                     onChange,
                     placeholder,
                     type = 'text',
                     className = '',
                     emailOptin = false,
                     onEmailOptinChange,
                   }) => {

  const getAutocompleteType = () => {
    return AUTOCOMPLETE_MAPPING[placeholder.toLowerCase()] || 'off';
  };

  const getValidationPattern = () => {
    const autocompleteType = getAutocompleteType();
    return VALIDATION_REGEX[autocompleteType];
  };

  const isValidInput = () => {
    const pattern = getValidationPattern();
    return pattern ? pattern.test(value) : false;
  };

  const isCompleted = isValidInput();

  const { trackPageViewCreateName } = useFidCardFunnelTracking();

  useEffect(() => {
    trackPageViewCreateName({});
  }, []);

  return (
    <div className="w-full relative">
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={getAutocompleteType()}
        className={clsx(
          'appear w-full h-24 p-4 geomanistMedium border',
          'shadow-[0px_6px_0px_0px_#e2e2e2] relative transform translate-y-[0px]',
          'focus:translate-y-[2px] transition-all duration-300 ease-in-out',
          'focus:shadow-[0px_6px_0px_0px_#596802] focus:bg-[#ECED90]',
          'border-gray-200 bg-white outline-none focus:border-[#596802] text-xl',
          '!rounded-2xl',
          {
            'pr-12 bg-[#ECED90] !shadow-[0px_6px_0px_0px_#596802] focus:!shadow-[0px_6px_0px_0px_#596802] focus:!border-[#596802] focus:!bg-[#ECED90]':
            isCompleted,
          },
          className,
        )}
      />

      {type === 'email' && (
        <OptinStep
          showEmailOptin={true}
          showSmsOptin={false}
          emailOptin={emailOptin}
          onEmailOptinChange={onEmailOptinChange}
          className="mt-6"
        />
      )}

      <style jsx global>{`
          /* Style des suggestions du navigateur */
          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus {
              -webkit-box-shadow: 0 0 0 30px white inset !important;
              -webkit-text-fill-color: inherit !important;
              transition: background-color 5000s ease-in-out 0s;
          }

          /* Style de la liste de suggestions */
          input::-webkit-calendar-picker-indicator {
              opacity: 0;
          }

          input::-webkit-contacts-auto-fill-button {
              visibility: hidden;
              pointer-events: none;
              position: absolute;
              right: 0;
          }
      `}</style>
    </div>
  );
};

export default InputStep;
